import { useDataLoaderHooks } from './use-dataloader-hooks'

export const useNotifyClick = () => {
  const { notifyClick } = useDataLoaderHooks()

  return notifyClick()
}

export default useNotifyClick
